import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressCircularLine15 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_24_326)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 15,
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-2-inside-1_24_326",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M30.2658 11.3647C30.7911 11.1941 31.0815 10.6285 30.8784 10.1149C29.7635 7.29633 27.8678 4.84538 25.4046 3.05573C22.9413 1.26607 20.0245 0.220517 16.9994 0.0312322C16.4482 -0.00325733 16 0.447715 16 1C16 1.55228 16.4483 1.99628 16.9992 2.03569C19.6016 2.22187 22.1075 3.13243 24.229 4.67376C26.3505 6.21509 27.9908 8.31702 28.9721 10.7345C29.1798 11.2462 29.7406 11.5354 30.2658 11.3647Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.2658 11.3647C30.7911 11.1941 31.0815 10.6285 30.8784 10.1149C29.7635 7.29633 27.8678 4.84538 25.4046 3.05573C22.9413 1.26607 20.0245 0.220517 16.9994 0.0312322C16.4482 -0.00325733 16 0.447715 16 1C16 1.55228 16.4483 1.99628 16.9992 2.03569C19.6016 2.22187 22.1075 3.13243 24.229 4.67376C26.3505 6.21509 27.9908 8.31702 28.9721 10.7345C29.1798 11.2462 29.7406 11.5354 30.2658 11.3647Z",
				stroke: "#4F49BA",
				strokeWidth: 4,
				strokeLinejoin: "round",
				mask: "url(#path-2-inside-1_24_326)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3908 11.2727V20H10.0698V12.5938H10.0186L7.93058 13.9574V12.696L10.1081 11.2727H11.3908ZM17.0925 10.8636L14.28 21.3125H13.1422L15.9547 10.8636H17.0925ZM21.0385 20.1193C20.5044 20.1193 20.0243 20.017 19.5982 19.8125C19.1749 19.6051 18.8368 19.321 18.584 18.9602C18.3311 18.5994 18.1962 18.1875 18.1792 17.7244H19.4576C19.4888 18.0994 19.655 18.4077 19.9561 18.6491C20.2573 18.8906 20.6181 19.0114 21.0385 19.0114C21.3738 19.0114 21.6706 18.9347 21.9292 18.7812C22.1905 18.625 22.3951 18.4105 22.5428 18.1378C22.6934 17.8651 22.7686 17.554 22.7686 17.2045C22.7686 16.8494 22.6919 16.5327 22.5385 16.2543C22.3851 15.9759 22.1735 15.7571 21.9036 15.598C21.6365 15.4389 21.3297 15.358 20.9831 15.3551C20.7189 15.3551 20.4533 15.4006 20.1863 15.4915C19.9192 15.5824 19.7033 15.7017 19.5385 15.8494L18.3326 15.6705L18.8226 11.2727H23.6209V12.402H19.9178L19.6408 14.8438H19.6919C19.8624 14.679 20.0882 14.5412 20.3695 14.4304C20.6536 14.3196 20.9576 14.2642 21.2814 14.2642C21.8127 14.2642 22.2857 14.3906 22.7005 14.6435C23.1181 14.8963 23.4462 15.2415 23.6848 15.679C23.9263 16.1136 24.0456 16.6136 24.0428 17.179C24.0456 17.7443 23.9178 18.2486 23.6593 18.6918C23.4036 19.1349 23.0485 19.4844 22.5939 19.7401C22.1422 19.9929 21.6238 20.1193 21.0385 20.1193Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_24_326",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgProgressCircularLine15;
